import { useApiClient } from '~/api-client';
import { useMutation } from '@tanstack/react-query';
import { BoatInquiry, DexBoatFormBootstrapView } from '@mark43/cad-api';
import { useForm } from 'react-hook-form';
import { DexQuerySubmissionBoatInquiry, DexQueriessubmitResource } from '@mark43/dex-api';
import { DexForm } from './dex-form';
import { DexFormModel } from '../types';
import { useIsLinkToAssignedEventCheckboxVisible } from './use-is-link-to-assigned-even-visible';
import { useBuildDexQuerySubmission } from './use-build-dex-query-submission';
import { useResetValuesAfterOriAliasChange } from './use-reset-values-after-ori-alias-change';

export function DexBoatForm({
    formBootstrapView,
}: {
    formBootstrapView: DexBoatFormBootstrapView;
}): React.ReactElement {
    const apiClient = useApiClient();
    const isLinkToAssignedEventCheckboxVisible = useIsLinkToAssignedEventCheckboxVisible();
    const defaultValues = {
        params: formBootstrapView.defaultValues,
        requestingUnitOption: null,
        agencyEventOption: null,
        ...(isLinkToAssignedEventCheckboxVisible ? { linkToAssignedEvent: true } : null),
    };
    const form = useForm<DexFormModel<BoatInquiry>>({
        mode: 'onBlur',
        defaultValues,
    });

    useResetValuesAfterOriAliasChange({
        formInitalValues: formBootstrapView.defaultValues,
        form,
        defaultValues,
    });

    const buildDexQuerySubmission = useBuildDexQuerySubmission(
        form,
        formBootstrapView.dexFormView.dexQuery
    );
    const sendQueryMutation = useMutation((formModel: DexFormModel<BoatInquiry>) => {
        return apiClient.request<DexQueriessubmitResource.SubmitBoatQuery>({
            service: 'DEX',
            method: 'POST',
            url: 'dex_queries/submit/boat_inquiry',
            data: buildDexQuerySubmission(formModel) as DexQuerySubmissionBoatInquiry,
        });
    });
    return (
        <DexForm
            dexFormView={formBootstrapView.dexFormView}
            defaultParams={formBootstrapView.defaultValues}
            form={form}
            sendQueryMutation={sendQueryMutation}
        />
    );
}
